import { render, staticRenderFns } from "./UserScore.vue?vue&type=template&id=2010ac8b&scoped=true"
import script from "./UserScore.vue?vue&type=script&lang=js"
export * from "./UserScore.vue?vue&type=script&lang=js"
import style0 from "./UserScore.vue?vue&type=style&index=0&id=2010ac8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2010ac8b",
  null
  
)

export default component.exports